module.exports = __webpack_public_path__ + "img/bg-footer.7d42f417.svg";